import { inject, observer } from 'mobx-react';
import React from 'react';
import { Telia1Benefits as Telia1BenefitsComponent } from '@teliaee/telia-common-components';
import config from '../Config';
import LanguageStore from '../stores/LanguageStore';
import SsoStore from '../stores/SsoStore';

interface Telia1BenefitsProps {
  languageStore?: LanguageStore;
  ssoStore?: SsoStore;
  disableTranslationsStatistics?: boolean;
  isTestEnvironment?: boolean;
}

const Telia1Benefits = (props: Telia1BenefitsProps): JSX.Element => {
  const {
    languageStore: { currentLanguage },
    ssoStore: { customerId },
    disableTranslationsStatistics,
    isTestEnvironment
  } = props;

  return (
    <Telia1BenefitsComponent
      app="public"
      tier={config.componentTier}
      language={currentLanguage}
      customerId={customerId}
      saveStats={true}
      disableTranslationsStatistics={disableTranslationsStatistics}
      isTestEnvironment={isTestEnvironment}
    />
  );
};

export default inject('languageStore', 'ssoStore')(observer(Telia1Benefits));
